import {
  SET_USER_TOKEN_DATA_MUTATION,
  SET_AUTO_LOGOUT_MUTATION,
  SET_IMAGE_MUTATION,
  SET_EDITION_MUTATION,
  SET_IDTOCANCEL_MUTATION,
  SET_FRRID_MUTATION,
  SET_TEAMACTIONS_MUTATION,
  SET_TROBSERVATIONS_MUTATION,
  SET_SECTION_MUTATION,
  SET_TRDETAILS_MUTATION,
  SET_TRID_MUTATION,
  SET_PLID_MUTATION,
  SET_PLOBSERVATIONS_MUTATION,
  SET_VDID_MUTATION,
  SET_VDOBSERVATIONS_MUTATION,
  SET_FPID_MUTATION,
  SET_FPOBSERVATIONS_MUTATION,
  SET_ID_MUTATION,
  SET_OBSERVATIONS_MUTATION,
  SET_EXPIRES_AT,
  SET_EXPIRY_WARNING,
  SET_COUNTDOWN,
  RESET_WARNING,
} from "../../storeconstants";

export default {
  [SET_USER_TOKEN_DATA_MUTATION](state, payload) {
    state.userID = payload.userID;
    state.firstname = payload.firstname;
    state.lastname = payload.lastname;
    state.email = payload.email;
    state.levelID = payload.levelID;
    state.level = payload.level;
    state.token = payload.token;
    state.img = payload.img;
    state.autoLogout = false;
    state.tebID = payload.tebID;
    state.tebName = payload.tebName;
    state.edition = payload.edition;
  },

  [SET_AUTO_LOGOUT_MUTATION](state) {
    state.autoLogout = true;
  },

  [SET_IMAGE_MUTATION](state, payload) {
    state.img = payload.img;
    state.firstname = payload.firstname;
    state.lastname = payload.lastname;
  },

  [SET_EDITION_MUTATION](state, payload) {
    state.edition = payload.edition;
  },

  [SET_IDTOCANCEL_MUTATION](state, payload) {
    state.idtocancel = payload.idtocancel;
  },

  [SET_FRRID_MUTATION](state, payload) {
    state.frrID = payload.frrID;
    state.projectFRR = payload.projectFRR;
    state.closedFRR = payload.closedFRR;
  },

  [SET_TRID_MUTATION](state, payload) {
    state.trID = payload.trID;
    state.projectTR = payload.projectTR;
    state.closedTR = payload.closedTR;
  },

  [SET_PLID_MUTATION](state, payload) {
    state.payloadID = payload.payloadID;
    state.projectPL = payload.projectPL;
    state.closedPL = payload.closedPL;
  },

  [SET_VDID_MUTATION](state, payload) {
    state.designID = payload.designID;
    state.projectVD = payload.projectVD;
    state.closedVD = payload.closedVD;
  },

  [SET_FPID_MUTATION](state, payload) {
    state.flightID = payload.flightID;
    state.projectFP = payload.projectFP;
    state.closedFP = payload.closedFP;
    state.apogee = payload.apogee;
  },

  [SET_TEAMACTIONS_MUTATION](state, payload) {
    state.teamactions = payload.teamactions;
    state.actionslevel = payload.actionslevel;
    state.actionscomplete = payload.actionscomplete;
  },

  [SET_TROBSERVATIONS_MUTATION](state, payload) {
    state.observationsTR = payload.observationsTR;
  },

  [SET_PLOBSERVATIONS_MUTATION](state, payload) {
    state.observationsPL = payload.observationsPL;
  },

  [SET_VDOBSERVATIONS_MUTATION](state, payload) {
    state.observationsVD = payload.observationsVD;
  },
  [SET_FPOBSERVATIONS_MUTATION](state, payload) {
    state.observationsFP = payload.observationsFP;
  },

  [SET_SECTION_MUTATION](state, payload) {
    state.section = payload.section;
  },

  [SET_TRDETAILS_MUTATION](state, payload) {
    state.trdetail = payload.trdetail;
  },
  /*teste*/

  [SET_ID_MUTATION](state, payload) {
    state.id = payload.id;
    state.project = payload.project;
    state.closed = payload.closed;
    state.apogee = payload.apogee;
  },

  [SET_OBSERVATIONS_MUTATION](state, payload) {
    state.observations = payload.observations;
  },

  // new mutations for expiry countdown/alert
  [SET_EXPIRES_AT](state, payload) {
    state.expiresAt = payload; // ms epoch
  },
  [SET_EXPIRY_WARNING](state, show) {
    state.showExpiryWarning = show;
  },
  [SET_COUNTDOWN](state, secs) {
    state.countdownSeconds = secs;
  },
  [RESET_WARNING](state) {
    state.showExpiryWarning = false;
    state.countdownSeconds = 0;
  },
};
